// Avatar colors derived from tgId — stable per user
const AVATAR_PALETTES = [
  { bg: "linear-gradient(135deg, #fb923c 0%, #f43f5e 100%)" }, // brand→coral
  { bg: "linear-gradient(135deg, #34d399 0%, #10b981 100%)" }, // emerald
  { bg: "linear-gradient(135deg, #60a5fa 0%, #6366f1 100%)" }, // blue→indigo
  { bg: "linear-gradient(135deg, #a78bfa 0%, #ec4899 100%)" }, // purple→pink
  { bg: "linear-gradient(135deg, #fbbf24 0%, #f97316 100%)" }, // amber→brand
  { bg: "linear-gradient(135deg, #f87171 0%, #ec4899 100%)" }, // coral→pink
  { bg: "linear-gradient(135deg, #2dd4bf 0%, #06b6d4 100%)" }, // teal→cyan
  { bg: "linear-gradient(135deg, #facc15 0%, #84cc16 100%)" }, // yellow→lime
];

export function avatarStyle(tgId: string): { background: string } {
  let hash = 0;
  for (let i = 0; i < tgId.length; i++) {
    hash = (hash * 31 + tgId.charCodeAt(i)) >>> 0;
  }
  const palette = AVATAR_PALETTES[hash % AVATAR_PALETTES.length];
  return { background: palette.bg };
}

export function avatarInitial(name: string): string {
  if (!name) return "?";
  const trimmed = name.trim();
  if (!trimmed) return "?";
  return trimmed.charAt(0).toUpperCase();
}

/**
 * Time-ago formatter. Returns localized t-key params: pass into i18n.t.
 */
export function timeAgo(
  iso: string | Date,
  t: (key: string, opts?: Record<string, unknown>) => string,
): string {
  const date = iso instanceof Date ? iso : new Date(iso);
  const diffSec = Math.max(0, Math.floor((Date.now() - date.getTime()) / 1000));
  if (diffSec < 60) return t("lenta.time.now");
  const diffMin = Math.floor(diffSec / 60);
  if (diffMin < 60) return t("lenta.time.minutesAgo", { count: diffMin });
  const diffHour = Math.floor(diffMin / 60);
  if (diffHour < 24) return t("lenta.time.hoursAgo", { count: diffHour });
  const diffDay = Math.floor(diffHour / 24);
  if (diffDay < 7) return t("lenta.time.daysAgo", { count: diffDay });
  const diffWeek = Math.floor(diffDay / 7);
  return t("lenta.time.weeksAgo", { count: diffWeek });
}

export function formatNumber(n: number): string {
  if (n >= 1000) return `${(n / 1000).toFixed(1).replace(/\.0$/, "")}k`;
  return String(n);
}
